const COUNTRY_NAMES = {
  PT: "Portugal",
  CH: "Suíça",
  FR: "França",
  LU: "Luxemburgo",
  BE: "Bélgica",
  DE: "Alemanha",
  UK: "Reino Unido",
  GB: "Reino Unido",
  ES: "Espanha",
  NL: "Países Baixos",
  BR: "Brasil",
  AO: "Angola",
  MZ: "Moçambique",
};

export function normalizeCountryIso(country) {
  const iso = String(country || "")
    .trim()
    .toUpperCase();
  return iso || null;
}

export function countryDisplayName(iso) {
  const code = normalizeCountryIso(iso);
  if (!code) return "";
  return COUNTRY_NAMES[code] || code;
}

export function countryFlagEmoji(iso) {
  const code = normalizeCountryIso(iso);
  if (!code || code.length !== 2) return "";
  const base = 0x1f1e6;
  return String.fromCodePoint(
    ...[...code].map((letter) => base + letter.charCodeAt(0) - 65)
  );
}

export function residenceCountryIso(propCountry, user) {
  return normalizeCountryIso(
    propCountry || (user && user.country ? user.country : null)
  );
}
